
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({})
    export default class Welcome extends Vue {
        toHomepage() {
            this.$router.replace('/');
        }

        toProfile() {
            this.$router.replace('/profile/config')
        }
    }

